import type { ApiQuery } from '../../../shared/api/contracts'
import { apiRequest } from './transport'

export async function fetchDashboardSummary(params: ApiQuery<'GET /admin/dashboard/summary'>, signal?: AbortSignal) {
  const query = new URLSearchParams(params)
  return apiRequest<'GET /admin/dashboard/summary'>(`/admin/dashboard/summary?${query}`, { signal })
}
